import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import DoughnutChartComponent from './DoughnutChartComponent';

const ArtifactHealthDoughnutComponent = ({
  title,
  pieData,
  pieSlices
}) => (
  <Col md={3}>
    <Row>
      <Col md={8} mdOffset={2}>
        <DoughnutChartComponent
          height={300}
          title={title}
          data={pieData}
          slices={pieSlices}
        />
      </Col>
    </Row>
  </Col>
);

ArtifactHealthDoughnutComponent.propTypes = {
  title: PropTypes.string.isRequired,
  pieData: PropTypes.array.isRequired,
  pieSlices: PropTypes.array.isRequired
};

export default ArtifactHealthDoughnutComponent;


// WEBPACK FOOTER //
// src/Components/ArtifactHealthDoughnutComponent.jsx